var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6311 8.33299C11.5697 8.37565 10.2977 9.72165 10.2977 10.6663C10.2977 11.6623 10.9304 12.2983 11.6311 12.333C12.2351 12.3623 12.9644 11.739 12.9644 10.6663C12.9644 9.66632 11.6924 8.37565 11.6311 8.33299ZM4.6884 12.333C4.9404 12.585 5.27506 12.7237 5.63106 12.7237C5.98706 12.7237 6.32173 12.585 6.57373 12.333L11.2404 7.66632L10.7691 7.19499L5.63106 2.05699L4.1024 0.52832L3.15973 1.47099L4.6884 2.99965L0.964397 6.72365C0.712397 6.97565 0.57373 7.31032 0.57373 7.66632C0.57373 8.02232 0.712397 8.35699 0.964397 8.60899L4.6884 12.333ZM5.63106 3.94232L9.35507 7.66632H1.90706L5.63106 3.94232Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColor);
export default __webpack_public_path__ + "static/media/ic_color.df6e3d4b6445590565a91f93b9f6f328.svg";
export { ForwardRef as ReactComponent };